import React from 'react';
import { Heart, Users, TrendingUp } from 'lucide-react';

const AnahatsevaSection = () => {
  return (
    <section style={{
      background: 'var(--bg-primary)',
      padding: '100px 7.6923%',
      position: 'relative'
    }}>
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        {/* Section Header */}
        <div style={{ textAlign: 'center', marginBottom: '60px' }}>
          <div style={{
            display: 'inline-block',
            padding: '8px 16px',
            background: 'rgba(0, 255, 209, 0.1)',
            border: '1px solid var(--brand-primary)',
            marginBottom: '20px',
            fontSize: '14px',
            color: 'var(--brand-primary)',
            fontWeight: '500'
          }}>
            SOCIAL IMPACT
          </div>
          <h2 className="display-medium" style={{ marginBottom: '20px' }}>
            <span style={{ color: 'var(--brand-primary)' }}>AnahatSeva</span> - Our Heart for Social Change
          </h2>
          <p className="body-medium" style={{ maxWidth: '800px', margin: '0 auto' }}>
            VDM's heart beats for social change through meaningful contribution to society
          </p>
        </div>

        {/* Content */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '60px',
          alignItems: 'center'
        }} className="anahatseva-grid">
          {/* Logo and Description */}
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '60px',
            background: 'rgba(255, 255, 255, 0.03)',
            border: '1px solid var(--border-subtle)'
          }}>
            <img 
              src="https://customer-assets.emergentagent.com/job_biz-innovations/artifacts/xfqb4ul6_image.png" 
              alt="AnahatSeva" 
              style={{
                height: '192px',
                objectFit: 'contain',
                marginBottom: '30px'
              }}
            />
            <Heart size={48} color="var(--brand-primary)" style={{ marginBottom: '20px' }} />
          </div>

          {/* Mission Statement */}
          <div>
            <p className="body-large" style={{ marginBottom: '30px', lineHeight: '1.8' }}>
              Through <strong>AnahatSeva</strong>, we help provide medical care for underprivileged children, in partnership with <strong>ImpactGuru</strong>.
            </p>
            
            <div style={{
              padding: '40px',
              background: 'rgba(0, 255, 209, 0.05)',
              border: '2px solid var(--brand-primary)',
              marginBottom: '30px'
            }}>
              <p className="body-large" style={{ 
                fontStyle: 'italic', 
                lineHeight: '1.8',
                color: 'var(--text-primary)'
              }}>
                "True success is not just business performance, but meaningful contribution to society."
              </p>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '30px' }}>
              <div style={{
                padding: '30px',
                background: 'rgba(255, 255, 255, 0.03)',
                border: '1px solid var(--border-subtle)',
                textAlign: 'center'
              }}>
                <Users size={40} color="var(--brand-primary)" style={{ marginBottom: '16px', display: 'block', margin: '0 auto 16px' }} />
                <h4 className="heading-3" style={{ marginBottom: '8px' }}>Medical Care</h4>
                <p className="body-small">Supporting underprivileged children</p>
              </div>

              <div style={{
                padding: '30px',
                background: 'rgba(255, 255, 255, 0.03)',
                border: '1px solid var(--border-subtle)',
                textAlign: 'center'
              }}>
                <TrendingUp size={40} color="var(--brand-primary)" style={{ marginBottom: '16px', display: 'block', margin: '0 auto 16px' }} />
                <h4 className="heading-3" style={{ marginBottom: '8px' }}>Social Impact</h4>
                <p className="body-small">Creating meaningful change</p>
              </div>
            </div>
          </div>
        </div>

        {/* Call to Action */}
        <div style={{
          marginTop: '60px',
          textAlign: 'center',
          padding: '60px',
          background: 'rgba(255, 255, 255, 0.03)',
          border: '1px solid var(--border-subtle)'
        }}>
          <h3 className="heading-1" style={{ marginBottom: '20px' }}>
            Join Us in Making a Difference
          </h3>
          <p className="body-medium" style={{ marginBottom: '30px', maxWidth: '700px', margin: '0 auto 30px' }}>
            Together, we can create a lasting impact on society while building successful businesses.
          </p>
          <a 
            href="https://www.impactguru.com" 
            target="_blank" 
            rel="noopener noreferrer"
            className="btn-primary"
            style={{ display: 'inline-flex', alignItems: 'center', gap: '12px' }}
          >
            Learn More About Our Impact
          </a>
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          .anahatseva-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </section>
  );
};

export default AnahatsevaSection;
